import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";

import "../styles/base.scss";
import { useSelector } from "react-redux";

const Layout = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return (
    <div className="layout">
      <Sidebar />
      <Outlet />
    </div>
  );
};

export default Layout;
